import { BrowserRouter, Route, Routes } from 'react-router-dom';
import App from '../App';
import Login from '../pages/login/Login';
import PlacePage from '../pages/place/PlacePage';
import RegisterPlace from '../pages/place/RegisterPlace';
import PlaceList from '../pages/place/PlaceList';
import PlaceEdit from '../pages/place/PlaceEdit';
import SearchPage from '../pages/search/SearchPage';
import SolicitationPage from '../pages/solicitacao/SolicitacaoPage';
import PendingPlaceOrdersPage from '../pages/solicitacao/PendingPlaceOrdersPage';
import UserRequestsPage from '../pages/requests/UserRequestsPage';
import { Alert, Link, Snackbar } from '@mui/material';
import { useEffect, useState } from 'react';
import AccountActivationPage from '../pages/activation/AccountActivationPage';

const AppRoutes = () => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    setOpen(true);
  }, []);

  return (
    <BrowserRouter>
      <Snackbar
        open={open}
        autoHideDuration={3000}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        sx={{ width: '100%' }}
      >
        <Alert severity="warning" onClose={() => setOpen(false)}>
          Esta é uma versão Beta do site. Algumas funcionalidades podem não estar disponíveis ou
          podem apresentar erros. Por favor, reporte quaisquer problemas ao
          <Link href="https://wa.me/48992083510" target="_blank">
            {' '}
            Suporte
          </Link>
          .
        </Alert>
      </Snackbar>
      <Routes>
        <Route path="/" element={<App />} />
        <Route path="/login" element={<Login />} />
        <Route path="/espaco/:id" element={<PlacePage />} />
        <Route path="/listar/espaco" element={<PlaceList />} />
        <Route path="/cadastrar/espaco" element={<RegisterPlace />} />
        <Route path="/promocional" element={<RegisterPlace />} />
        <Route path="/editar/espaco/:id" element={<PlaceEdit />} />
        <Route path="/pesquisar" element={<SearchPage />} />
        <Route path="/solicitacao" element={<SolicitationPage />} />
        <Route path="/solicitacoes-abertas" element={<PendingPlaceOrdersPage />} />
        <Route path="/minhas-solicitacoes" element={<UserRequestsPage />} />
        <Route path="/ativacao" element={<AccountActivationPage />} />
      </Routes>
    </BrowserRouter>
  );
};

export default AppRoutes;
